module.exports = __webpack_public_path__ + "static/media/hero-image-01.34d7e545.jpg";